import { BroadcastQuality } from '@core/types';

// Re-exported so the router package (which depends on @core/shared, not @core/types) can use them.
export { BroadcastQuality, DEFAULT_BROADCAST_QUALITY, parseBroadcastQuality } from '@core/types';

export interface SiteSettings {
    isWhitelabel: boolean;
    isProduction: boolean;
    title: string;
    code: string;
    defaultLanguage: Language;
    defaultBroadcastQuality: BroadcastQuality;
    logoUrl?: string;
    /** The words shown in the logo image, for its text alternative; the title when the logo shows just that */
    logoText: string;
    countdownImageUrl?: string;
    countdownVideoUrl?: string;
    footerLinks: FooterLink[];
    baseUrl: string;
}

export interface FooterLink {
    title: string;
    url?: string;
    urls?: { [language: string]: string };
}

export type Language = 'en' | 'fr' | 'nl';

export const languages: { code: Language; title: string }[] = [
    {
        code: 'nl',
        title: 'Nederlands'
    },
    {
        code: 'en',
        title: 'English'
    },
    {
        code: 'fr',
        title: 'Français'
    }
];
